import { LangUri } from '@catawiki/runtime-toolkit';

export const langUri = LangUri.LangUri.of(
  typeof window !== 'undefined' ? window.location.href : ''
);

export const wrapWithGenerateLocale = (url: string) => (locale: string) =>
  LangUri.generateLocalePath(locale, url);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyFunction = (...args: any[]) => string;

export const wrapWithGenerateLocaleWithParams =
  <F extends AnyFunction>(urlFunc: F) =>
  (locale: string) =>
  (...params: Parameters<F>): string =>
    LangUri.generateLocalePath(locale, urlFunc(...params));

type WrappedObject<T> = {
  [K in keyof T]: T[K] extends string
    ? (locale: string) => string
    : T[K] extends AnyFunction
      ? (locale: string) => (...args: Parameters<T[K]>) => ReturnType<T[K]>
      : never;
};

export const wrapObjectWithGenerateLocale = <
  T extends Record<string, string | AnyFunction>,
>(
  object: T
): WrappedObject<T> =>
  Object.keys(object).reduce((acc, key) => {
    const url = object[key as keyof T];
    if (typeof url === 'string') {
      acc[key as keyof T] = wrapWithGenerateLocale(url);
    } else {
      acc[key as keyof T] = wrapWithGenerateLocaleWithParams(
        url as AnyFunction
      );
    }
    return acc;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  }, {} as any);
